import { render, staticRenderFns } from "./FullReport_OLD.vue?vue&type=template&id=72aa6f8e&scoped=true&"
import script from "./FullReport_OLD.vue?vue&type=script&lang=js&"
export * from "./FullReport_OLD.vue?vue&type=script&lang=js&"
import style0 from "./FullReport_OLD.vue?vue&type=style&index=0&id=72aa6f8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aa6f8e",
  null
  
)

export default component.exports